<script setup lang="ts">
  import ModalStack from '@/common/components/modal/ModalStack.vue'
  import { ref, watch } from 'vue'
  import { useStore } from '@/store'
  import AuditLogView from '@/common/components/auditlog/AuditLogView.vue'

  const store = useStore()
  const stack = ref<any[]>([])

  watch(() => store.state.app.auditLogVisible, (value) => {
    if (value) {
      stack.value = [{ name: 'auditlog' }]
    } else {
      stack.value = []
    }
  })
</script>

<template>
  <ModalStack :stack="stack" @backdropClick="store.commit('app/setAuditLogVisible', false)">
    <template #default>
      <AuditLogView />
    </template>
  </ModalStack>
</template>